import { Box, Typography } from '@material-ui/core';

import { ExplorerUserCard } from 'features/explorer/components';
import { useGraduatedUsersListPerYear } from 'features/scorecard/hooks';
import { FeedSkeleton } from 'shared/components/ui';

interface ClassViewDedailsModalProps {
  year: string;
}

export function ClassViewDedailsModal({ year }: ClassViewDedailsModalProps) {
  const { activeUsers, invitedUsers, loading } = useGraduatedUsersListPerYear({
    // Sort users alphabetically by last name.
    // https://github.com/jebelapp/jebel/issues/1601#issuecomment-2471474935
    variables: { graduatingYear: year, sort: [{ lastName: 'DESC' }] },
  });

  if (loading) {
    return <FeedSkeleton count={3} />;
  }

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem">
      <Box display="grid" gridGap="1rem">
        <Typography color="secondary">Active Alumni ({activeUsers.length})</Typography>

        <Box>
          {activeUsers.map(user => (
            <ExplorerUserCard key={user.id} data={user} withDivider withMessage />
          ))}
        </Box>

        {activeUsers.length === 0 && (
          <Typography color="textSecondary">No active users found for this class year</Typography>
        )}
      </Box>

      <Box display="grid" gridGap="1rem">
        <Typography color="secondary">Invited Alumni ({invitedUsers.length})</Typography>

        <Box>
          {invitedUsers.map(user => (
            <ExplorerUserCard key={user.id} data={user} withDivider withMessage />
          ))}
        </Box>

        {invitedUsers.length === 0 && (
          <Typography color="textSecondary">No invited users found for this class year</Typography>
        )}
      </Box>
    </Box>
  );
}
